module.exports = __webpack_public_path__ + "img/gb13806_2_c.prt.cca43738.jpg";